import _WidgetBaseSP from 'more/_WidgetBaseSP';
import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './IndividualDataHome.html?raw';
import on from 'dojo/on';
import "./IndividualDataTypes";
import GenericDialog from '../../moreCore/UI/GenericDialog/GenericDialog';
import CollapsibleSection from './CollapsibleSection/CollapsibleSection';
import ContactInfoDataForm from './EditForms/ContactInfoDataForm';
import BankInfoDataForm from './EditForms/BankInfoDataForm';
import BioInfoDataForm from './EditForms/BioInfoDataForm';
import FinancialInsuranceInfoDataForm from './EditForms/FinancialInsuranceInfoDataForm';
//import OtherInfoDataForm = require("./EditForms/OtherInfoDataForm");
import PassportInfoDataForm from './EditForms/PassportInfoDataForm';
import PersonalInfoDataForm from './EditForms/PersonalInfoDataForm';
import PersonalDocumentInfoDataForm from './EditForms/PersonalDocumentInfoDataForm';
import FurtherAddressessInfoDataForm from './EditForms/FurtherAddressessInfoDataForm';
//import ProvisionInfoDataForm = require("./EditForms/ProvisionInfoDataForm");
//import TaxInfoDataForm = require("./EditForms/TaxInfoDataForm");


class IndividualDataHome extends compose(_WidgetBaseSP) {
    templateString: any = template;

    individualDataHomeHead: HTMLElement;
    individualDataHomeErrorContainer: HTMLElement;
    individualDataHomeErrorMessage: HTMLElement;
    individualDataContainer: HTMLElement;
    btnUnfoldAll: HTMLElement;

    collapsedSections: Array<IndividualData_CollapsedSections> = [];

    editSectionData(section: MdsLax<InstanceType<typeof CollapsibleSection>>, sectionName: string): void {

        let requestUrl = window.appRoot + "IndividualDataSheet/GetSectionDataByName";
        this.StandbyStart();

        this.RequestManager.post(
            requestUrl,
            {
                sectionName: sectionName
            },
            lang.hitch(this, this._onGetSectionDataByNameResponse, sectionName, section),
            lang.hitch(this, this._onGetSectionDataByNameError, section),
            false // sync
        );
    }

    _onGetSectionDataByNameResponse(sectionName: any, section: MdsLax<InstanceType<typeof CollapsibleSection>>, data: any ): void {

        this.StandbyStop();
        console.debug("DATA:", data, "NAME:", sectionName);//???

        let form = null;
        let header = "";
        let dlg = new GenericDialog();

        dlg.setCloseOnEscape(true);
        dlg._setCloseBtnAttr(true);
        dlg._setTopCloseBtnAttr(true);
        dlg.closeOnEscape = true;
        dlg.closeOnEnter = false;
        dlg.destroyOnClose = true;

        switch (sectionName) {
            case "contact_info_data":
                form = new ContactInfoDataForm();
                header = this.translations["IndividualDataSheet_EditForm_Header_contact_info_data"];

                dlg.addButton("saveBtn", "Save", lang.hitch(form, form._onClick_saveBtn), null, "w3-margin-left mds-button-base w3-padding round mds-hover-bright w3-disabled accentBG", "fas fa-save", false, "last");
                on(form, "change_isDirty", lang.hitch(this, this.setSaveBtnActive, dlg.getButtonByName("saveBtn")));
                break;

            case "further_addresses":
                form = new FurtherAddressessInfoDataForm();
                header = this.translations["IndividualDataSheet_EditForm_Header_further_addresses"];

                dlg.addButton("saveBtn", "Save", lang.hitch(form, form._onClick_saveBtn), null, "w3-margin-left mds-button-base w3-padding round mds-hover-bright w3-disabled accentBG", "fas fa-save", false, "last");
                on(form, "change_isDirty", lang.hitch(this, this.setSaveBtnActive, dlg.getButtonByName("saveBtn")));
                break;

            case "personal_info_data":
                form = new PersonalInfoDataForm();
                header = this.translations["IndividualDataSheet_EditForm_Header_personal_info_data"];

                dlg.addButton("saveBtn", "Save", lang.hitch(form, form._onClick_saveBtn), null, "w3-margin-left mds-button-base w3-padding round mds-hover-bright w3-disabled accentBG", "fas fa-save", false, "last");
                on(form, "change_isDirty", lang.hitch(this, this.setSaveBtnActive, dlg.getButtonByName("saveBtn")));
                break;
            case "personal_documents":
                form = new PersonalDocumentInfoDataForm();
                header = this.translations["IndividualDataSheet_EditForm_Header_personal_documents_data"];
                break;
            case "passport_data":
                form = new PassportInfoDataForm();
                header = this.translations["IndividualDataSheet_EditForm_Header_passport_data"];
                break;
            case "financial_insurance_data":
                form = new FinancialInsuranceInfoDataForm();
                header = this.translations["IndividualDataSheet_EditForm_Header_insurance_data"];

                dlg.addButton("saveBtn", "Save", lang.hitch(form, form._onClick_saveBtn), null, "w3-margin-left mds-button-base w3-padding round mds-hover-bright w3-disabled accentBG", "fas fa-save", false, "last");
                on(form, "change_isDirty", lang.hitch(this, this.setSaveBtnActive, dlg.getButtonByName("saveBtn")));
                break;
            case "bank_data":
                form = new BankInfoDataForm();
                header = this.translations["IndividualDataSheet_EditForm_Header_bank_data"];
                break;
            case "bio_data_de":
                form = new BioInfoDataForm();
                form.sectionName = IndividualData_SectionName.BioInfo_DE;
                header = this.translations["IndividualDataSheet_EditForm_Header_bio_data_de"];

                dlg.addButton("saveBtn", "Save", lang.hitch(form, form._onClick_saveBtn), null, "w3-margin-left mds-button-base w3-padding round mds-hover-bright w3-disabled accentBG", "fas fa-save", false, "last");
                on(form, "change_isDirty", lang.hitch(this, this.setSaveBtnActive, dlg.getButtonByName("saveBtn")));
                break;
            case "bio_data_en":
                form = new BioInfoDataForm();
                form.sectionName = IndividualData_SectionName.BioInfo_EN;
                header = this.translations["IndividualDataSheet_EditForm_Header_bio_data_en"];

                dlg.addButton("saveBtn", "Save", lang.hitch(form, form._onClick_saveBtn), null, "w3-margin-left mds-button-base w3-padding round mds-hover-bright w3-disabled accentBG", "fas fa-save", false, "last");
                on(form, "change_isDirty", lang.hitch(this, this.setSaveBtnActive, dlg.getButtonByName("saveBtn")));
                break;
        }

        if (form !== null) {

            section._showErrorMessage("", false);

            dlg._setHeaderAttr(header);

            form.loadFormData(data);

            form.placeAt(dlg.textNode);
            dlg.show();
            on(form, "DataForm_close", lang.hitch(dlg, dlg.Close));
            on(form, "DataForm_close", lang.hitch(this, this.refreshData));

        } else {

            section._showErrorMessage("no form?", true);
            dlg.destroy();
        }
    }

    setSaveBtnActive(btn: any, isDirty: boolean): void {

        if (isDirty) {

            this.UiModder.domClass.remove(btn.node, "w3-disabled");
        } else {

            this.UiModder.domClass.add(btn.node, "w3-disabled");
        }
    }

    refreshData(): void {

        this.UiModder.domConstruct.empty(this.individualDataContainer);

        this.GetLoggedPersonInfo();
    }

    GetLoggedPersonInfo(): void {
        let requestUrl = window.appRoot + "IndividualDataSheet/GetLoggedPersonInfo";
        this.StandbyStart();

        this.RequestManager.post(
            requestUrl,
            null,
            lang.hitch(this, this._onGetLoggedPersonInfoResponse),
            lang.hitch(this, this._onGetLoggedPersonInfoError),
            false // sync
        );
    }

    private _onGetLoggedPersonInfoResponse(info: IndividualData_BasicInfoSheet): void {
        
        for (let prop in info) {

            let cs = new CollapsibleSection();
            let dataHtml: string;
            let isEditable: boolean = true;

            switch (prop) {
                case "passport_data":

                    //TODO !!!

                    //if (info[prop].passId) {

                    //    let btn = this.UiModder.domConstruct.create("button", {
                    //        class: "mds-button-base w3-padding round tertiaryBG mds-hover-bright",
                    //        style: "min-width:120px; cursor: pointer;",
                    //        innerHTML: this.translations["IndividualDataSheet_Button_GetScan"]
                    //    }, cs.collapsibleButtonContainer);

                    //    on(btn, "click", lang.hitch(this, this._onClickCheckScan, info[prop].passId));
                    //}

                    break;
                case "financial_insurance_data":

                    //TODO !!!

                    //if (info.financial_insurance_data.is_VAT_exemption) {

                    //    let btn = this.UiModder.domConstruct.create("button", {
                    //        class: "mds-button-base w3-padding round tertiaryBG mds-hover-bright",
                    //        style: "min-width:120px; cursor: pointer;",
                    //        innerHTML: this.translations["IndividualDataSheet_Button_GetExemptionDocu"]
                    //    }, cs.collapsibleButtonContainer);

                    //    on(btn, "click", lang.hitch(this, this._onClickCheckTaxDocument));
                    //}

                    break;

                case "bio_data_de":
                case "bio_data_en":

                    isEditable = false;
                    break;
                default:
                    //
            }

            if (!dataHtml && info[prop] && info[prop].infoHTML) {

                dataHtml = info[prop].infoHTML;
            } else {

                dataHtml = this.translations["IndividualDataSheet_CollapsibleSection_EmptyProp"];
            }   

            cs.sectionName = prop;
            cs.collapsibleSectionEditFunction = lang.hitch(this, this.editSectionData, cs);
            cs.collapsibleContainer.innerHTML = dataHtml;
            cs.collapsibleHeading.innerHTML = this.translations[`IndividualDataSheet_CollapsibleSection_Header_${prop}`];
            cs.placeAt(this.individualDataContainer);

            this.collapsedSections.push({ sectionName: prop, isCollapsed: true });

            //###
            cs.isEditable = isEditable; // definition in EVIS??
            //###

            on(cs, "CollapsibleSection_isCollapsed", lang.hitch(this, this.setCollapsedBool, prop));
            on(this, "CollapsibleSection_UnfoldAll", lang.hitch(cs, cs.expandSection));
            on(this, "CollapsibleSection_CollapseAll", lang.hitch(cs, cs.collapseSection));
        }

        this.StandbyStop();
    }

    setCollapsedBool(sectionName, obj): void {

        this.collapsedSections.filter(x => x.sectionName === sectionName)[0].isCollapsed = obj.isCollapsed;

        if (this.collapsedSections.filter(x => x.isCollapsed === true).length === 0) { // TODO better?

            this.btnUnfoldAll.innerHTML = `<i class="fas fa-caret-up"></i> ${this.translations["General_CollapseAll"]}`;
        } else {

            this.btnUnfoldAll.innerHTML = `<i class="fas fa-caret-down"></i> ${this.translations["General_UnfoldAll"]}`;
        }
    }

    //EVENTS
    _onClickCheckScan(passId: string): void {

        this.checkIfFileExist(IndividualData_File.PassportScan, passId);

        //download
    }

    checkIfFileExist(fileType: IndividualData_File, entityId: string): void {

        let requestUrl = window.appRoot + "IndividualDataSheet/CheckIfFileExist";

        this.StandbyStart();

        this.RequestManager.post(
            requestUrl,
            {
                fileType: fileType,
                entityId: entityId
            },
            lang.hitch(this, this._onCheckIfFileExistResponse, fileType, entityId),
            lang.hitch(this, this._onCheckIfFileExistError),
            false // sync
        );
    }

    _onCheckIfFileExistResponse(fileType: IndividualData_File, entityId: string, response: { result: boolean }): void {

        this._showErrorMessage("", false);

        let fileExists: boolean = response.result;
        let message: string;
        let icon: string;
        let buttons: "yesno" | "ok" | "close" | "okcancel";
        let callback: any = null;

        if (fileExists) {

            message = this.translations["IndividualDataSheet_Dialog_DownloadFileMessage_Found"];
            icon = "fas fa-question";
            buttons = "yesno";
            callback = lang.hitch(this, this.downloadScanFile, fileType, entityId);
        } else {

            message = this.translations["IndividualDataSheet_Dialog_DownloadFileMessage_NotFound"];
            icon = "fas fa-info-circle";
            buttons = "ok";
        }


        let dlg = new GenericDialog();

        dlg.show(message, this.translations["IndividualDataSheet_Dialog_DownloadFileMessage_Header"], null, icon, buttons, callback);
        dlg.destroyOnClose = true;
        this.UiModder.domStyle.set(dlg.modalDlgContentNode, "width", "600px");
        this.UiModder.domStyle.set(dlg.modalDlgContentNode, "margin-top", "100px");

        this.StandbyStop();
    }

    downloadScanFile(fileType: IndividualData_File, entityId: string, dlgResult: any): void {

        if (dlgResult === 2) {

            location.href = window.appRoot + "IndividualDataSheet/DownloadScanFile?fileType=" + fileType + "&entityId=" + entityId;
        }
    }

    _onClickCheckTaxDocument(): void {

        alert("Check for confirming docu");
    }

    _onClick_Button_UnfoldAll(): void {

        if (this.collapsedSections.filter(x => x.isCollapsed === true).length === 0) {

            this.emit("CollapsibleSection_CollapseAll");
            this.btnUnfoldAll.innerHTML = `<i class="fas fa-caret-down"></i> ${this.translations["General_UnfoldAll"]}`;
        } else {

            this.emit("CollapsibleSection_UnfoldAll");
            this.btnUnfoldAll.innerHTML = `<i class="fas fa-caret-up"></i> ${this.translations["General_CollapseAll"]}`;
        }
    }

    //ERRORS

    private _onCheckIfFileExistError(error: any): void {
        this.StandbyStop();
        this._showErrorMessage(error.Message, true);
    }

    private _onGetLoggedPersonInfoError(error: any): void {
        this.StandbyStop();
        this._showErrorMessage(error.Message, true);
    }

    private _onGetSectionDataByNameError(section: MdsLax<InstanceType<typeof CollapsibleSection>>, error: any): void {
        this.StandbyStop();

        section._showErrorMessage(error.Message, true);
    }

    private _showErrorMessage(msg: any, show: boolean): void {

        this.individualDataHomeErrorMessage.innerHTML = msg;

        this.UiModder.domClass.remove(this.individualDataHomeErrorContainer, "w3-hide");

        if (!show) this.UiModder.domClass.add(this.individualDataHomeErrorContainer, "w3-hide");
    }

    //BASE
    postCreate(): void {
        super.postCreate.apply(this, arguments as any);
    }
    startup(): void {
        super.startup.apply(this, arguments as any);

        this.GetLoggedPersonInfo();
    }
}

export default mdsWidget(IndividualDataHome);